import React from 'react';
import {FormattedMessage} from 'react-intl';
import Util from '../../util/util';

type PasswordHelpTextProps = {
	password: string;
};

export function PasswordHelpText({password}: PasswordHelpTextProps): React.JSX.Element {
	return (
		<div className="password-help-text">
			<div className="title">
				<FormattedMessage id="user-settings.security.password_help.password_must_contain" />
			</div>
			<div className={'line' + (Util.validateMin8Chars(password) ? ' valid' : '')}>
				<div className={Util.validateMin8Chars(password) ? 'check' : 'cross'} />
				<FormattedMessage id="user-settings.security.password_help.at_least_8" />
			</div>
			<div className={'line' + (Util.validate1Digit(password) ? ' valid' : '')}>
				<div className={Util.validate1Digit(password) ? 'check' : 'cross'} />
				<FormattedMessage id="user-settings.security.password_help.one_number" />
			</div>
			<div className={'line' + (Util.validate1Letter(password) ? ' valid' : '')}>
				<div className={Util.validate1Letter(password) ? 'check' : 'cross'} />
				<FormattedMessage id="user-settings.security.password_help.one_letter" />
			</div>
			<div className={'line' + (Util.validate3Identical(password) ? ' valid' : '')}>
				<div className={Util.validate3Identical(password) ? 'check' : 'cross'} />
				<FormattedMessage id="user-settings.security.password_help.max_2_identical" />
			</div>
		</div>
	);
}
